import { VisualizationCell } from '@/components/loop-dashboard/shared/cells/VisualizationCell';
import { calculateRatioData } from '@/components/loop-dashboard/utils/ratioCalculations';
import { useVisibleItemHealth } from '../context/VisibleHealthContext';
import type { ItemsTableRow } from '../types';
import { CellTextSkeleton } from './withSkeleton';

export const TimeSpentVsPlannedCell = ({ row }: { row: ItemsTableRow }) => {
  const health = useVisibleItemHealth(row.id);

  if (health === undefined) return <CellTextSkeleton />;
  if (health === null) return null;

  const { aggregatedActualSeconds, aggregatedPlanSeconds } = health;

  return (
    <VisualizationCell
      ratioData={calculateRatioData(aggregatedActualSeconds, aggregatedPlanSeconds)}
      actualSeconds={aggregatedActualSeconds}
      planSeconds={aggregatedPlanSeconds}
      isParentRow={false}
    />
  );
};
